import PropTypes from "prop-types";
import { Link } from "react-scroll";
import cn from "classnames";
import styles from "components/shared/residencies/LinkSmooth.module.scss";

export default function LinkSmooth({
  children,
  to,
  container = null,
  className = null,
}) {
  return (
    <Link
      to={to}
      smooth="easeOutQuint"
      duration={700}
      className={cn(styles.component, className)}
      containerId={container}
    >
      {children}
    </Link>
  );
}

LinkSmooth.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired,
  container: PropTypes.string,
  className: PropTypes.node,
};
